import React from "react";

import { useAuth0 } from "../react-auth0-wrapper.js";
import { Helmet } from "react-helmet";

import { Link } from "react-router-dom";
import { makeStyles } from "@mui/styles";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import { Alert, Container } from "@mui/material";

function Home() {
  return (
    <Container maxWidth="md">
      <Helmet>
        <link rel="canonical" href="http://developer.sosinventory.com/" />
        <meta
          name="description"
          content="Welcome to SOS Inventory's developer portal, your source of API information for SOS Inventory. "
        />
      </Helmet>
      <h1>SOS Inventory Developer Portal</h1>
      <HomeBody />
    </Container>
  );
}

const useStyles = makeStyles({
  root: {
    marginTop: "20px",
    cursor: "pointer",
    fontWeight: "300",
    color: "#333",
  },
  cardHeader: {
    marginBottom: "-0.5em",
  },
  cardBody: {
    marginTop: "0",
  },
});

function HomeBody() {
  const classes = useStyles();
  const { isAuthenticated, loginWithRedirect, authError } = useAuth0();
  return (
    <React.Fragment>
      {authError && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {authError}
        </Alert>
      )}
      <p>
        Welcome to SOS Inventory's developer portal, your source of API
        information for SOS Inventory. This site allows you to register your
        applications and to access complete documentation for all API endpoints.
      </p>
      <GridContainer>
        <GridItem md={6}>
          <CredentialsCard
            authenticated={isAuthenticated}
            loginWithRedirect={loginWithRedirect}
          >
            <CardHeader>
              <h2 className={classes.cardHeader}>
                Register your applications.
              </h2>
            </CardHeader>
            <CardBody>
              <p className={classes.cardBody}>
                A Client ID and Client Secret are needed to use SOS
                Inventory&apos;s API endpoints. Select MY APPS in the header to
                register your application with us and obtain client credentials.
              </p>
            </CardBody>
          </CredentialsCard>
        </GridItem>
        <GridItem md={6}>
          <Link to="/apidoc" style={{ textDecoration: "none" }}>
            <Card className={classes.root}>
              <CardHeader>
                <h2 className={classes.cardHeader}>
                  Access API documentation.
                </h2>
              </CardHeader>
              <CardBody>
                <p className={classes.cardBody}>
                  Click the API DOCUMENTATION link in the header to access
                  complete documentation on all API endpoints for SOS Inventory.
                </p>
              </CardBody>
            </Card>
          </Link>
        </GridItem>
      </GridContainer>
    </React.Fragment>
  );
}

function CredentialsCard(props) {
  const classes = useStyles();
  if (props.isAuthenticated) {
    return (
      <Link to="/myapps">
        <Card>{props.children}</Card>
      </Link>
    );
  }
  if (!props.isAuthenticated) {
    return (
      <Card
        onClick={() =>
          props.loginWithRedirect({
            redirect_uri: `${window.location.protocol}//${window.location.host}/myapps`,
          })
        }
        className={classes.root}
      >
        {props.children}
      </Card>
    );
  }
}

export default Home;
